<main class="px-8 xl:px-0 py-16">
    <section id="sign-up-success" class="container mx-auto max-w-screen-xl prose leading-normal">
        <div class="row">
            <!-- Left side image -->
            <div class="col-12 col-md-2 d-flex justify-content-center justify-content-md-start">
                <img src="https://assets.syngentaebiz.com/images/media/ssp-icon-verification-email.svg"
                    class="img-fluid imageSize" alt="Image">
            </div>
            <!-- Right side text -->
            <div class="col-12 col-md-10 d-flex justify-content-md-start">
                <div class="sign-up-success__copy ml-10 pt-3 topMargin4">
                    <h2 class="md:text-[36px] sm:text-[24px] mb-8 mt-0">The enrollment period has closed.</h2>
                    <p class="md:text-[22px] sm:text-[18px] sm:mb-0">The 2025 Storen Satisfaction Program enrollment
                        period has closed.*</p>
                </div>
            </div>
        </div>
        <!-- Breaking line -->
        <h3 class="breakline mb-5"></h3>

        <div class="sign-up-success__copy ml-0 mt-0">
            <h2 class="md:text-[36px] sm:text-[24px] mb-8 mt-0">
                Interested in learning more about Storen<sup>&#174;</sup> corn herbicide?
            </h2>
            <!-- Button 1 -->
            <div class="row contentAlign">
                <div class="col-xs-12 col-sm-6 col-md-8">
                    <p class="md:text-[24px] sm:text-[18px]">
                        If you're interested in learning more about Storen<sup>&#174;</sup> corn herbicide:
                    </p>
                </div>
                <div class="col-xs-6 col-md-4 btnAlign">
                    <button type="button" class="btn__blue" (click)="buttonOneClicked()">Learn More</button>
                </div>
            </div>

            <!-- Button 2 -->
            <div class="row contentAlign">
                <div class="col-xs-12 col-sm-6 col-md-8">
                    <p class="md:text-[24px] sm:text-[18px]">
                        If you enrolled in the Storen Satisfaction
                        Program and you're looking for the log-in page:
                    </p>
                </div>
                <div class="col-xs-6 col-md-4 btnAlign">
                    <button type="button" class="btn__blue" (click)="buttonTwoClicked()">Log In</button>
                </div>
            </div>
        </div>
        <!-- Small text -->
        <p class="smallSubText mt-5">*Participants must have enrolled in the Program on or before 11:59:59 PM EDT on
            March 10, 2025.</p>
    </section>
</main>
